import React from "react"
import styled from "styled-components"

const NoticeModal = styled.div`
h2 {
    color: #ed2028 !important;
    text-transform: uppercase;
    margin-top: 0px;
}
.title {
    margin: 10px auto 5px;
    text-align: center;
    text-transform: uppercase;
    color: #ed2028 !important;
    font-size: 20px;
    font-weight: bold;
}
p {
    margin-bottom: 20px;
    padding: 0px 20px;
}
li {
    margin-bottom: 10px;
}
.btn {
    background: #428bca;
    border: #357ebd solid 1px;
    border-radius: 3px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    padding: 8px 15px;
    text-decoration: none;
    text-align: center;
    min-width: 60px;
    position: relative;
    transition: color .1s ease;
}
.btn:hover {
    background: #357ebd;
}
.btn.btn-big {
    font-size: 18px;
    padding: 15px 20px;
    min-width: 100px;
}
.btn-close {
    color: #ed2028;
    background: transparent;
    font-size: 30px;
    font-weight: bold;
    text-decoration: none;
    position: absolute;
    border: none;
    right: 20px;
    top: 12px;
}
.btn-close:hover {
    color: #919191;
}
.modal:target:before {
    display: none;
}
.modal:before {
    content:"";
    display: block;
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1199;
}
.modal .modal-dialog {
    background: #fefefe;
    border: #d6d6d6 solid 1px;
    border-radius: 5px;
    margin: 0px auto !important;
    position: fixed;
    z-index: 1200;

    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    transform: translate(0, 0);
    -webkit-transition: -webkit-transform 0.3s ease-out;
    -moz-transition: -moz-transform 0.3s ease-out;
    -o-transition: -o-transform 0.3s ease-out;
    transition: transform 0.3s ease-out;
    @media screen and (min-width: 768px) {
        max-width: 65%;
        left: 17%;
        top: 20%;
    }
    @media screen and (max-width: 767px) {
        max-width: 90%;
        left: 5%;
        top: 10%;
    }
}
.modal:target .modal-dialog {
    top: -100%;
    -webkit-transform: translate(0, -500%);
    -ms-transform: translate(0, -500%);
    transform: translate(0, -500%);
}
.modal-body {
    padding: 20px 0px;
    overflow: scroll;
    scroll-behavior: smooth;
    height: 400px;
    max-height: 50vh;
}
.modal-header, .modal-footer {
    padding: 10px 20px;
}
.modal-header {
    border-bottom: #eeeeee solid 1px;
}
.modal-header h2 {
    font-size: 20px;
}
.modal-footer {
    border-top: #eeeeee solid 1px;
    text-align: right;
}
`

const Notice = () => (
    <NoticeModal>
    <div className="modal" id="modal-one" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-header">
                <div className="title">Advisory</div>
                <a href="#modal-one" className="btn-close" aria-hidden="true">×</a>
            </div>
            <div className="modal-body">
                <div style={{
            clear: "both",
            background: "#eeeeee",
            marginTop: "-36px",
            paddingTop: "36px",
            paddingBottom: "25px"
            }}>
                <p style={{color: "#195998", fontSize: "16px"}}><b>Notice on Public Day Tickets</b></p>
                <p>In light of the evolving coronavirus situation, the volume of Public Day tickets will be scaled down for the well-being and safety of all visitors. If you have made a purchase, your Public Day tickets will be honoured, and we look forward to welcoming you at Singapore Airshow 2020.  If you have yet to purchase your tickets, please visit <a href="https://www.sistic.com.sg/events/sas1502" target="_blank">SISTIC</a> to get yours before they are sold out.</p>
                <p style={{color: "#195998", fontSize: "16px"}}><b>In light of the evolving coronavirus situation, please do not visit Singapore Airshow 2020 if:</b></p>
                <ul>
                    <li>You are unwell with fever or respiratory symptoms such as cough, runny nose or shortness of breath.
                Please seek medical attention immediately.</li>
                    <li>You are placed on Leave of Absence (LOA).</li>
                    <li>You have recent travel history to mainland China, in particular Hubei province, within the last 14 days.</li>
                </ul>
                </div>
<div style={{background: "#195998",
            color: "#FFFFFF",
            fontWeight: "400",
            textAlign: "center",
            padding: "15px 10px",
            margin: "0px auto 40px"}}>
    Please remain vigilant and practise good personal hygiene.
</div>
                <p style={{color: "#195998", fontSize: "16px"}}><b>Enhanced precautionary measures taken at Singapore Airshow 2020</b></p>
                <ul>
                    <li>Enhanced cleaning and refuse management to maintain high standards of hygiene and cleanliness</li>
                    <li>Availability of hand sanitisers to attendees</li>
                    <li>Deployment of a team of doctors and medics on standby for visitors who feel unwell</li>
                    <li>Temperature screening at Singapore Expo and CEC access points</li>
                    <li>Seat-tagging at seated events to facilitate contact tracing</li>
                    <li>“No-contact” policy such as adoption of alternative greetings</li>
                </ul>
            </div>
            </div>
    </div>
    </NoticeModal>
)

export default Notice